import { render, staticRenderFns } from "./BuyTokens.vue?vue&type=template&id=6e572d0c&scoped=true"
import script from "./BuyTokens.vue?vue&type=script&lang=js"
export * from "./BuyTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e572d0c",
  null
  
)

export default component.exports